import React, { useEffect } from 'react';

export const ChildSafety = () => {
    useEffect(() => {
        // Add meta noindex, nofollow
        let meta = document.querySelector('meta[name="robots"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.name = "robots";
            document.head.appendChild(meta);
        }
        const originalContent = meta.content;
        meta.content = "noindex, nofollow";

        // Update document title
        const originalTitle = document.title;
        document.title = "Flintt Child Safety Standards";

        return () => {
            // Cleanup on unmount
            if (originalContent) {
                meta.content = originalContent;
            } else {
                document.head.removeChild(meta);
            }
            document.title = originalTitle;
        };
    }, []);

    return (
        <div className='main about'>
            <div className='aside'><div></div></div>

            <div className='content has-aside static'>
                <a href="https://flintt.me/"><div className='nav-logo'></div></a>

                <h1>FLINTT CHILD SAFETY STANDARDS</h1>

                <p>Version number: 1.0</p>
                <p>Effective date: 17.07.2025</p>

                <h2>Who we are</h2>
                <p>We are Brather Ltd trading as “Flintt.me”. Our company information is at the end of this document.</p>

                <h2>Our stance on Child Safety</h2>
                <p>Flintt is a strictly 18+ dating platform. Minors are not permitted to use our service.</p>

                <p>We maintain a zero-tolerance policy toward child sexual abuse material (CSAM) and any form of exploitation involving minors. This policy is strictly enforced in accordance with our Terms and Conditions and Privacy Policy.</p>

                <h2>Our safety measures include:</h2>
                <ul>
                    <li>Mandatory age verification (18+ only)</li>
                    <li>User reporting system</li>
                    <li>Block and report functionality</li>
                    <li>Active content moderation</li>
                    <li>Immediate removal of violating content</li>
                    <li>Cooperation with law enforcement authorities when required</li>
                </ul>

                <h2>Reporting concerns</h2>
                <p>Users may report safety concerns via the in-app reporting system or by contacting us at:</p>

                <p>
                    <a href="mailto:info@flintt.me">info@flintt.me</a>
                </p>

                <p>Flintt is committed to maintaining a safe and responsible environment for all users.</p>

                <h2>Company Information</h2>
                <ul>
                    <li>Company name: Brather Ltd</li>
                    <li>Trading name: “Flintt.me”</li>
                    <li>Country of incorporation: England and Wales</li>
                    <li>Registered number: 16306917</li>
                    <li>Registered office and contact address: 48 The Boulevard, Horsham, England, RH12 1EP</li>
                    <li>Contact email address: <a href="mailto:info@flintt.me">info@flintt.me</a></li>
                    <li>Other contact information: See our website/contact page</li>
                </ul>
            </div>
        </div>
    );
};
